import { ReactNode } from "react";

const toButtonClass = () => {
  return `flex h-full w-full items-center justify-center rounded-full gap-x-2`;
};

type ButtonProps = {
  type?: "button" | "reset" | "submit";
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
};

export const BaseButton = ({
  type = "button",
  onClick,
  className,
  children,
  disabled,
}: ButtonProps) => (
  <button
    type={type}
    className={`${toButtonClass()} ${className}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);
